import React from 'react';
import PropTypes from 'prop-types';

const YoutubeAlternative = ({ color = '#00ADEF', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={color}
      d="M21.583 4.5H2.417c-.25 0-.417.167-.417.417v14.166c0 .25.167.417.417.417h19.166c.25 0 .417-.167.417-.417V4.917c0-.25-.167-.417-.417-.417ZM15.333 17v1.667H8.667V17h6.666Zm-12.5-.833V7.833h18.334v8.334H2.833ZM8.667 7V5.333h6.666V7H8.667Zm12.5 0h-5V5.333h5V7ZM2.833 5.333h5V7h-5V5.333Zm0 11.667h5v1.667h-5V17Zm18.334 1.667h-5V17h5v1.667Z"
    />
    <path
      fill={color}
      d="M14.667 11.583 10.083 9.5c-.083 0-.25 0-.416.083-.084.084-.167.167-.167.334v4.166c0 .167.083.25.167.334.083.083.166.083.25.083h.166l4.584-2.083a.458.458 0 0 0 .25-.417.458.458 0 0 0-.25-.417Zm-4.334 1.834v-2.834L13.5 12l-3.167 1.417Z"
    />
  </svg>
);

YoutubeAlternative.propTypes = {
  color: PropTypes.string
};

export default YoutubeAlternative;
